<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pb-2 mt-1" >
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('attendances.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0 tools-view-height"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="4" align="end" class="py-0">
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="modalCheckIn = true;" v-permission="'attendances.create'">
                        {{ $t('attendances.check_in') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 25, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalDelete" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                                <h3 class="text-uppercase">
                                    {{ $t('attendances.delete') }}
                                </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="py-3 my-3 text-center">
                            <v-col cols="12">
                                <h5>{{ $t('attendances.message') }}</h5>
                            </v-col>
                        </v-row>
                        
                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalDelete = false">{{ $t('attendances.no') }}</v-btn>
                            <v-btn color="error" @click="deleteAttendance">
                                {{ $t('attendances.yes') }}
                            </v-btn>
                        </div>
                    </v-card-text> 
                    <div class="marker"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalCheckIn" persistent max-width="90%">
                <v-card >
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h3 class="text-uppercase mt-4">
                                {{ $t('attendances.check_in') }}
                            </h3>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="formattendances">
                            <v-row align="center" justify="center" class="py-3 my-3 text-center" v-if="user_validated">
                                <v-col cols="10" class="mb-4">
                                    <img v-if="user.image != '' && user.image != null" style="max-width: 300px !important; max-height: 300px !important;" :src="user.image" :alt="user.name">
                                </v-col>

                                <v-col class="my-0 py-0" cols="10">
                                    <label style="font-size: 16px; font-weight: bold;">{{ user.name }}</label>
                                </v-col>
                                <v-col class="my-0 py-0" cols="10">
                                    <label style="font-size: 16px; font-weight: bold;">{{ user.position }}</label>
                                </v-col>
                            </v-row>

                            <v-row align="center" justify="center" class="py-3 my-3 text-center" v-if="!user_validated">
                                <v-col cols="10">
                                    <v-text-field class="py-0 mx-2" v-model="user_code" counter="7" :rules="numeric_required" :label="$t('attendances.user_code')"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                        
                        <div class="d-flex" v-if="!user_validated">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="cancelValidation()">{{ $t('attendances.cancel') }}</v-btn>
                            <v-btn class="white_highlight--text" color="secondary"  @click="validateUser()">
                                {{ $t('attendances.validate') }}
                            </v-btn>
                        </div>
                        
                        <v-row justify="center" align="center" class="mt-6" v-if="user_validated">
                            <v-btn class="mx-3" text @click="cancelValidation()">{{ $t('attendances.cancel') }}</v-btn>
                            <v-btn class="white_highlight--text" color="secondary"  @click="saveCheckIn()">
                                {{ $t('attendances.save') }}
                            </v-btn>
                        </v-row>
                        
                    </v-card-text> 
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
export default {
    computed: {
        headers(){
            return [
                { text: this.$t('attendances.date'), align: "center", value: 'attendance_date', class: 'text-uppercase' },
                { text: this.$t('attendances.name'), align: "center", value: 'user.name', class: 'text-uppercase' },
                { text: this.$t('attendances.entry'), align: "center", value: 'entry_time', class: 'text-uppercase' },
                { text: this.$t('attendances.departure'), align: "center", value: 'exit_time', class: 'text-uppercase' },
                { text: this.$t('attendances.actions'), align: "center", value: 'actions', class: 'text-uppercase', sortable: false },
            ];
        },
        numeric_required(){
            return [
                v => /^(|\d)+$/.test(v) || this.$t('edit_appointment.product_details.validations.numbers'),
                v => !!v || this.$t('edit_appointment.validations.required_field'),
                v => v == null || v.toString().length == 0 || v.toString().length == 7 || this.$t('attendances.length'),
            ];
        },
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalDelete: false,
            modalCheckIn: false,
            user_code: '',
            user: {
                image: null,
                name: '',
                position: ''
            },
            id_attendance: '',
            user_validated: false,
            actions: [
                {
                    name: this.$t('attendances.delete'),
                    icon: {
                        color: 'accent',
                        icon: 'delete'
                    },
                    method: 'askDelete',
                    permission: "attendances.delete"
                }
            ],
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
        }
    },
    mounted(){
        this.$store.state.module = "headers.attendances";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){
            this.props.items = [];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.get(this.$store.state.chronosApi + 'attendances?page=' + this.props.meta.page + '&per_page=' + this.props.meta.per_page + '&search=' + this.props.search + '&sort_by=' + JSON.stringify(this.props.sort_by), {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status === 200){
                    console.log(response.data)
                    this.props.meta = response.data.meta;

                    response.data.data.forEach( x => {
                        if(x.entry_time != null) x.entry_time = x.entry_time.split("T")[1].substring(0,5);
                        if(x.exit_time != null) x.exit_time = x.exit_time.split("T")[1].substring(0,5);
                        x['actions'] = JSON.parse(JSON.stringify(this.actions));
                        x.parameters = {"id": x.id};
                        this.props.items.push(x);
                    })
                    this.$store.state.loaderProps.visible = false;
                }
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        askDelete(attendances){
            console.log(attendances)
            this.modalDelete = true;
            this.id_attendance = attendances.id;
        },
        deleteAttendance(){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.delete(this.$store.state.chronosApi + 'attendances/' + this.id_attendance, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status === 200){
                    this.modalDelete = false;
                    this.index();
                    this.$store.state.loaderProps.visible = false;
                }
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        validateUser(){
            const lsToken = localStorage.getItem("access_token");

            var validate = this.$refs.formattendances.validate();
            if(!validate){
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('attendances.user_code_not_valid')
                }
                return;
            }

            this.$store.state.loaderProps.visible = true;

            this.$http.get(this.$store.state.chronosApi + 'users_get_info/' + this.user_code, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.data.user.data.attributes.has_an_attendance == false){
                    this.user.image = response.data.user.data.attributes.image;
                    this.user.name = response.data.user.data.attributes.name + " " + response.data.user.data.attributes.paternal_surname + " " + response.data.user.data.attributes.maternal_surname;
                    this.user.position = response.data.user.data.attributes.position;
                    this.user_validated = true;
                    this.$store.state.loaderProps.visible = false;
                }
                else {
                    this.saveCheckIn();
                }
                
            })
            .catch((response) => {
                this.user = {
                    image: null,
                    name: '',
                    position: ''
                }

                this.user_validated = true;

                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: this.$t('pendings.responses.error')
                    }
                }
            }).finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        saveCheckIn(){
            var validate = this.$refs.formattendances.validate();
            if(!validate){
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('attendances.user_code_not_valid')
                }
                return;
            }

            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            this.$http.post(this.$store.state.chronosApi + 'attendances', {"employee_number": this.user_code}, {headers: {Authorization: lsToken}})
            .then((response) => {
                if(response.status === 201 || response.status === 200){
                    this.cancelValidation();
                    this.index();
                    this.$store.state.loaderProps.visible = false;
                }
            })
            .catch((response) => {
                this.$store.state.loaderProps.visible = false;
                if(response.status !== 200){
                    this.snackbar = {
                        visible: true,
                        color: 'red',
                        text: response.response.data.error
                    }
                }
            })
            .finally(() => {
                this.$store.state.loaderProps.visible = false;
            });
        },
        cancelValidation(){
            this.user_code = "",
            this.user = {
                image: null,
                name: '',
                position: ''
            };
            this.user_validated = false;
            this.modalCheckIn = false;
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 

            this.index();
        },
    },
     watch: {
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}
</script>

<style>

</style>